// extracted by mini-css-extract-plugin
module.exports = {"summary":"_2iQ084_VQTjhq6OiAWwfSg","total":"QGc_twGCPyLCXBFspSIhb","title":"_1aVuRt5a7KzubMml32KARW","remaining-quota":"POHEOp3kEtTnCGxoHJKti"};